@if (currentCurrency$ | async; as currency) {
  @if (label && appearance === 'outline') {
    <mat-label>
      {{ label | translate | async }} <span class="required">*</span></mat-label
    >
  }
  <mat-form-field [appearance]="appearance" [style.fontSize.px]="fontSize">
    <mat-select
      [multiple]="multiple"
      [placeholder]="
        (placeholder | translate | async) +
        (required && appearance !== 'outline' ? ' *' : '')
      "
      [formControl]="control"
    >
      @for (option of options; track option) {
        <mat-option [value]="getOptionValue(option)">
          <span [innerHTML]="getOptionName(option, currency)"></span>
        </mat-option>
      }
    </mat-select>
    @if (control.touched) {
      <mat-error>
        @if (control.errors?.required) {
          @if (label || placeholder) {
            {{ label || placeholder | translate | async }}
            {{ 'is required' | translate | async }}
          } @else {
            {{ 'This field is required' | translate | async }}
          }
        }
      </mat-error>
    }
  </mat-form-field>
}
